import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import Chatbot from "./components/Chatbot/Chatbot";
import PaymentHold from "./components/PaymentHold";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Chatbot />
    <App />
  </BrowserRouter>
);

serviceWorkerRegistration.unregister();
reportWebVitals();
